import { render, staticRenderFns } from "./DownloadAppPage.vue?vue&type=template&id=1d030336&scoped=true&"
import script from "./DownloadAppPage.vue?vue&type=script&lang=ts&"
export * from "./DownloadAppPage.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadAppPage.vue?vue&type=style&index=0&id=1d030336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d030336",
  null
  
)

export default component.exports